import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-heading text-foreground-900 mb-4">约炮攻略</h3>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              真实有效的约炮技巧与平台推荐平台。致力于帮助每位用户安全、愉快地享受约会生活。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/category/yuepao-jiqiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">约炮技巧</Link></li>
              <li><Link to="/category/pingtai-tuijian" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">平台推荐</Link></li>
              <li><Link to="/category/liaotian-huashu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">聊天话术</Link></li>
              <li><Link to="/category/anquan-zhinan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">安全指南</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-3">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 约炮攻略. 本站内容仅供成年人参考，请理性对待约会关系。
          </p>
          <p className="text-xs text-foreground-500">
            安全约会，尊重他人，享受生活
          </p>
        </div>
      </div>
    </footer>
  );
}